import React, {useLayoutEffect, useRef} from 'react'
import {Lang} from 'yougile-lang'
import {RequiredOptions} from 'yougile-model'
import {Tracking, TrackingEvent} from '@common/tracking'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {getValueByKey} from '@components/common/base/select-with-dropdown/utils'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {Sticker} from '@extensions/sticker/sticker'
import {TwSetting} from './containers'
import {useCommonHandlers} from './use-common-handlers'

const values = ['offer', 'require']

// need a function to avoid problems
// with init ru language
const stickerOptions = (): OptionsItem[] => [
  {key: 'require', text: Lang.msg.myStickers.requireToDefineValue},
  {key: 'offer', text: Lang.msg.myStickers.offerToDefineValue}
]

// eslint-disable-next-line max-lines-per-function
export const RequireStickerSettingsContent = (props: CommonProps) => {
  const {state, sticker, setState} = props
  const {required} = state
  const {toggleRequired} = useCommonHandlers(sticker, setState)

  const isActive = required && values.includes(required)

  const firstUpdate = useRef(true)
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    if (Sticker.getType(sticker) === 'deadline') {
      if (isActive) {
        if (required === 'offer') {
          void Tracking.send(
            TrackingEvent.stickerSettingsSuggestDeadlineWhenTaskCreated_Enable
          )
          void Tracking.send(
            TrackingEvent.stickerSettingsRequireDeadlineWhenTaskCreated_Disable
          )
        }
        if (required === 'require') {
          void Tracking.send(
            TrackingEvent.stickerSettingsRequireDeadlineWhenTaskCreated_Enable
          )
          void Tracking.send(
            TrackingEvent.stickerSettingsSuggestDeadlineWhenTaskCreated_Disable
          )
        }
      } else {
        required === 'offer' &&
          void Tracking.send(
            TrackingEvent.stickerSettingsSuggestDeadlineWhenTaskCreated_Disable
          )
        required === 'require' &&
          void Tracking.send(
            TrackingEvent.stickerSettingsRequireDeadlineWhenTaskCreated_Disable
          )
      }
    }
  }, [isActive, required])

  const checkboxDataTestId =
    'checkbox-require-sticker-settings-' + (isActive ? 'checked' : 'unchecked')
  const options = stickerOptions()
  const value = getValueByKey(options, required)

  return (
    <TwSetting>
      <CheckboxNew
        className="py-8"
        value={isActive ?? false}
        onChange={() => toggleRequired(isActive ? 'none' : 'require')}
        label={Lang.msg.myStickers.whenCreatingTask}
        dataTestId={checkboxDataTestId}
      />
      <SelectWithDropdown
        disabled={!isActive}
        className="ml-24 !w-[380px]"
        options={options}
        onChange={x => toggleRequired(x.key as RequiredOptions)}
        placeholder={Lang.msg.myStickers.requireToDefineValue}
        value={value}
        variant="new"
        // dataTestId="dropdown-require-sticker-settings"
      />
    </TwSetting>
  )
}
